import { Alert, Anchor, Button, Select, Stack, Text } from '@mantine/core'
import { IconChevronRight, IconInfoCircle } from '@tabler/icons-react'

interface CityStepProps {
  value: string
  onChange: (city: string) => void
  onNext: () => void
}

const CITIES = [
  { value: 'espoo', label: 'Espoo' },
  { value: 'helsinki', label: 'Helsinki' },
  { value: 'kauniainen', label: 'Kauniainen' },
  { value: 'kirkkonummi', label: 'Kirkkonummi' },
  { value: 'vantaa', label: 'Vantaa' },
  { value: 'muu', label: 'Muu' },
]

export function CityStep({ value, onChange, onNext }: CityStepProps) {
  return (
    <Stack gap="md">
      <div>
        <Text size="xl" fw={600} mb="xs">
          Valitse kaupunki
        </Text>
        <Text size="sm" c="dimmed">
          Missä kiinteistö sijaitsee?
        </Text>
      </div>

      <Select
        label="Kaupunki"
        placeholder="Valitse kaupunki"
        data={CITIES}
        value={value}
        onChange={(val) => val && onChange(val)}
        size="md"
        required
      />

      <Alert
        icon={<IconInfoCircle size={18} />}
        color="blue"
        variant="light"
        styles={{ message: { fontSize: 'var(--mantine-font-size-sm)' } }}
      >
        Käynnin kesto on noin tunti
      </Alert>

      {value === 'muu' && (
        <Alert
          icon={<IconInfoCircle size={18} />}
          title="Palvelualueen ulkopuolella"
          color="blue"
        >
          <Text>Valitettavasti emme vielä palvele valitsemaasi aluetta.</Text>
          <Text mt="xs">
            Markku palvelee tällä hetkellä pääkaupunkiseudulla ja sen
            lähialueilla.
          </Text>
          <Text mt="xs">
            Jos olet kiinnostunut palveluistamme, ota yhteyttä:
          </Text>
          <Text mt="xs">
            📧{' '}
            <Anchor href="mailto:info@markku.fi" fw={500}>
              info@markku.fi
            </Anchor>
          </Text>
          <Text mt="xs" c="dimmed">
            Laajennamme palvelualuettamme jatkuvasti!
          </Text>
        </Alert>
      )}

      <Button
        onClick={onNext}
        disabled={!value || value === 'muu'}
        size="md"
        fullWidth
        rightSection={<IconChevronRight size={18} />}
      >
        Jatka
      </Button>
    </Stack>
  )
}
